module.exports =
{

  _init: function ()
  {
    this.onChangeNodes()
    this.onConfirm()

  },

  onChangeNodes: function ()
  {

    $('#pods').not('.js-ignore').on('keyup change', function ()
    {

      var pods = parseInt($(this).val() || 0)

      if (pods > 6)
      {
        pods = 6
      }

      var pods_total = pods * parseFloat($('#pods-price').val() || 0.00)

      $('#pods-total').text(Number(pods_total).toLocaleString(undefined, {minimumFractionDigits: 2}))

    }).addClass('js-ignore')

  },

  onConfirm: function ()
  {

    $('.js-confirm').not('.js-ignore').click(function ()
    {
      APPLICATION.PodConfigurator.confirm.showTerms()
    }).addClass('js-ignore')

  },

  

  showTerms: function ()
  {
    APPLICATION._APPLICATION.customModal(
      "/pod-configurator/terms?pods=" + $("#pods").val(),
      "PodConfigurator",
      "terms"
    );
  }

}